import cleverFox from "../asstes/audio/voicequest/clever-fox.mp3";
import kindElephant from "../asstes/audio/voicequest/kind-elephant.mp3";
import braveBird from "../asstes/audio/voicequest/brave-bird.mp3";
import slowTurtle from "../asstes/audio/voicequest/slow-turtle.mp3";
import honestBoy from "../asstes/audio/voicequest/honest-boy.mp3";
import wiseOwl from "../asstes/audio/voicequest/wise-owl.mp3";

// --- difficult level ---
import goldenFeather from "../asstes/audio/voicequest/golden-feather.mp3";
import mountainLion from "../asstes/audio/voicequest/mountain-lion.mp3";
import lostStar from "../asstes/audio/voicequest/lost-star.mp3";

// --- Hard level ---
import enchantedRiver from "../asstes/audio/voicequest/enchanted-river.mp3";
import kingdomOfShadows from "../asstes/audio/voicequest/kingdom-of-shadows.mp3";


const stories = {
  moderate: [
    {
      id: 1,
      title: "The Kind Elephant",
      audioUrl: kindElephant,
      storyText:
        "In a forest, there lived an elephant who was very kind. One day, a small rabbit got stuck in a bush and cried for help. The elephant heard him and gently used his trunk to free the rabbit. The next day, hunters came to the forest and fell into a trap. The rabbit saw them and called all animals to help. Together, they scared the hunters away. The elephant and rabbit became best friends.",
      questions: [
        {
          question: "Who helped the rabbit?",
          options: ["The elephant", "The tiger", "The monkey", "The deer"],
          answer: "The elephant",
        },
        {
          question: "What did the rabbit do later?",
          options: [
            "Forgot the elephant",
            "Helped save the elephant and others",
            "Moved to another forest",
            "Built a trap",
          ],
          answer: "Helped save the elephant and others",
        },
        {
          question: "What is the moral?",
          options: [
            "Kindness always comes back",
            "Don’t go near bushes",
            "Never trust animals",
            "Be stronger than others",
          ],
          answer: "Kindness always comes back",
        },
      ],
    },
    {
      id: 2,
      title: "The Brave Little Bird",
      audioUrl: braveBird,
      storyText:
        "A baby bird had fallen from its nest during a storm. It tried to fly but couldn’t. A kind squirrel saw it and brought some food. The bird kept practicing every day. After a week, it flapped its wings and finally flew high into the sky. The squirrel clapped happily, proud of his little friend.",
      questions: [
        {
          question: "What happened to the baby bird?",
          options: [
            "It fell from its nest",
            "It got lost",
            "It was hungry",
            "It was scared of the squirrel",
          ],
          answer: "It fell from its nest",
        },
        {
          question: "Who helped the bird?",
          options: ["A rabbit", "A squirrel", "A fox", "A monkey"],
          answer: "A squirrel",
        },
        {
          question: "What can we learn?",
          options: [
            "Keep trying until you succeed",
            "Flying is easy",
            "Always stay in the nest",
            "Never make friends",
          ],
          answer: "Keep trying until you succeed",
        },
      ],
    },
    {
      id: 3,
      title: "The Slow but Steady Turtle",
      audioUrl: slowTurtle,
      storyText:
        "Once, a proud rabbit laughed at a turtle for being too slow. The turtle challenged him to a race. The rabbit ran fast and was far ahead, but he decided to nap under a tree. The turtle kept moving slowly without stopping. When the rabbit woke up, he saw the turtle crossing the finish line first! The rabbit felt ashamed but learned a good lesson.",
      questions: [
        {
          question: "Who won the race?",
          options: ["The rabbit", "The turtle", "Both together", "None"],
          answer: "The turtle",
        },
        {
          question: "Why did the rabbit lose?",
          options: [
            "He fell",
            "He slept during the race",
            "He forgot the way",
            "He stopped to eat",
          ],
          answer: "He slept during the race",
        },
        {
          question: "What is the moral?",
          options: [
            "Slow and steady wins the race",
            "Run as fast as you can",
            "Sleep more to win",
            "Always show off",
          ],
          answer: "Slow and steady wins the race",
        },
      ],
    },
    {
      id: 4,
      title: "The Honest Boy",
      audioUrl: honestBoy,
      storyText:
        "A boy named Raju found a shiny wallet on his way to school. He opened it and saw some money and an ID card. Instead of keeping it, he took it to the police station. The next day, the owner came to thank Raju and gave him a chocolate as a reward. Raju felt happy that he did the right thing.",
      questions: [
        {
          question: "What did Raju find?",
          options: ["A wallet", "A book", "A phone", "A key"],
          answer: "A wallet",
        },
        {
          question: "What did Raju do with the wallet?",
          options: [
            "Kept it for himself",
            "Gave it to the police",
            "Hid it in his bag",
            "Gave it to his friend",
          ],
          answer: "Gave it to the police",
        },
        {
          question: "What is the moral of the story?",
          options: [
            "Honesty is the best policy",
            "Always keep gifts",
            "Don’t go to school",
            "Never talk to strangers",
          ],
          answer: "Honesty is the best policy",
        },
      ],
    },
    {
      id: 5,
      title: "The Wise Old Owl",
      audioUrl: wiseOwl,
      storyText:
        "In a big oak tree lived a wise old owl. Every day, he quietly watched what was happening around him. The squirrel played, the birds sang, and sometimes the fox argued with others. The owl never interrupted or shouted. He just listened. As days passed, the animals started coming to him for advice. They respected him because he spoke less but said things that mattered. The owl taught them that listening makes you wiser.",
      questions: [
        {
          question: "Where did the owl live?",
          options: ["In a cave", "In an oak tree", "In a nest on the ground", "In the mountains"],
          answer: "In an oak tree",
        },
        {
          question: "What did the owl do every day?",
          options: [
            "Slept all day",
            "Flew around the forest",
            "Watched and listened quietly",
            "Played with the squirrel",
          ],
          answer: "Watched and listened quietly",
        },
        {
          question: "What is the moral of the story?",
          options: [
            "Listening makes you wiser",
            "Always speak loudly",
            "Don’t trust owls",
            "Playing is better than thinking",
          ],
          answer: "Listening makes you wiser",
        },
      ],
    },
    {
      id: 6,
      title: "The Clever Fox",
      audioUrl: cleverFox,
      storyText:
        "One hot day, a thirsty fox was looking for water. After a long search, he found a pot with a little water at the bottom. But his mouth couldn’t reach it. He thought for a while and got an idea! He picked up small stones and dropped them one by one into the pot. Slowly, the water rose up, and the fox happily drank it. He wagged his tail proudly — clever thinking had saved the day!",
      questions: [
        {
          question: "What problem did the fox face?",
          options: ["He was hungry", "He was thirsty", "He was lost", "He was sleepy"],
          answer: "He was thirsty",
        },
        {
          question: "How did the fox solve his problem?",
          options: [
            "He broke the pot",
            "He called his friends",
            "He put stones in the pot",
            "He dug a hole",
          ],
          answer: "He put stones in the pot",
        },
        {
          question: "What is the moral of the story?",
          options: [
            "Think smartly to solve problems",
            "Always ask for help",
            "Don’t drink too much water",
            "Never play with stones",
          ],
          answer: "Think smartly to solve problems",
        },
      ],
    },
  ],

  difficult: [
      {
        id: 7,
        title: "The Golden Feather",
        audioUrl: goldenFeather,
        storyText:
          "Once, a poor farmer found a golden feather in his chicken’s nest. Every day, the hen laid one golden feather, and soon, the farmer became rich. But greed entered his heart. He thought, 'If I take all the feathers at once, I’ll be rich faster!' So he killed the hen — but found no more feathers inside. The farmer cried, realizing his greed had taken away his only blessing.",
        questions: [
          {
            question: "What did the farmer find?",
            options: [
              "A golden egg",
              "A golden feather",
              "A golden coin",
              "A silver feather",
            ],
            answer: "A golden feather",
          },
          {
            question: "Why did the farmer lose everything?",
            options: [
              "He was greedy",
              "He shared the feathers",
              "He sold the hen",
              "He forgot to feed the hen",
            ],
            answer: "He was greedy",
          },
          {
            question: "What can we learn?",
            options: [
              "Greed destroys happiness",
              "Work fast to be rich",
              "Gold is magical",
              "Animals bring luck",
            ],
            answer: "Greed destroys happiness",
          },
        ],
      },
      {
        id: 8,
        title: "The Mountain Lion’s Lesson",
        audioUrl: mountainLion,
        storyText:
          "In the high mountains lived a strong lion who thought he was the greatest. One day, he roared so loudly that rocks began to fall. A small mountain goat saved the cubs by leading them to safety. The lion realized that even the smallest creature could do great things. From that day, he respected every animal, big or small.",
        questions: [
          {
            question: "What caused the rocks to fall?",
            options: [
              "The lion’s loud roar",
              "A strong wind",
              "The goat’s jump",
              "A hunter’s attack",
            ],
            answer: "The lion’s loud roar",
          },
          {
            question: "Who saved the lion cubs?",
            options: ["The fox", "The goat", "The eagle", "The tiger"],
            answer: "The goat",
          },
          {
            question: "What lesson did the lion learn?",
            options: [
              "Respect everyone, big or small",
              "Be proud of your roar",
              "Lions should stay alone",
              "Goats are dangerous",
            ],
            answer: "Respect everyone, big or small",
          },
        ],
      },
      {
        id: 9,
        title: "The Lost Star",
        audioUrl: lostStar,
        storyText:
          "One quiet night, a small star fell from the sky into the ocean. It was scared and felt lonely. A kind dolphin saw its glow and promised to help. Together, they swam to the surface, and the dolphin leaped high, sending the star back to the sky. The star twinkled brighter than ever, grateful for the dolphin’s kindness. Every night, it shines to guide sailors safely home.",
        questions: [
          {
            question: "Where did the star fall?",
            options: ["In the forest", "In the ocean", "In a mountain", "On a cloud"],
            answer: "In the ocean",
          },
          {
            question: "Who helped the star?",
            options: ["A fish", "A whale", "A dolphin", "A bird"],
            answer: "A dolphin",
          },
          {
            question: "What is the message of the story?",
            options: [
              "Helping others makes the world brighter",
              "Stars should not fall",
              "Only dolphins can jump high",
              "The ocean is dangerous",
            ],
            answer: "Helping others makes the world brighter",
          },
        ],
      },
  ],

  hard: [
    {
      id: 10,
      title: "The Enchanted River",
      audioUrl: enchantedRiver,
      storyText:
        "Many years ago, in a peaceful village, there flowed a wide, sparkling river. But this was no ordinary river — it was said to grant one wish each year to a kind-hearted soul. A young boy named Arav dreamed of helping his sick mother, so he decided to find the river. The path was long and full of challenges — he had to cross dark woods, climb steep rocks, and share his last piece of bread with a hungry fox. When he finally reached the river, its water glowed in the moonlight. A gentle voice spoke, saying, 'Because you showed kindness and courage, your wish shall be granted.' The next morning, Arav returned home to find his mother healthy again. The villagers never doubted the legend after that. The river remained still and shining — a reminder that true kindness always finds its reward.",
      questions: [
        {
          question: "What was special about the river?",
          options: [
            "It granted one wish each year",
            "It was full of gold",
            "It had dangerous fish",
            "It changed colors every day",
          ],
          answer: "It granted one wish each year",
        },
        {
          question: "Why did Arav go to the river?",
          options: [
            "To swim and play",
            "To find treasure",
            "To help his sick mother",
            "To meet the fox",
          ],
          answer: "To help his sick mother",
        },
        {
          question: "What challenges did Arav face?",
          options: [
            "Dark woods and steep rocks",
            "Heavy rain and snow",
            "Wild elephants",
            "A deep cave",
          ],
          answer: "Dark woods and steep rocks",
        },
        {
          question: "Why did the river grant Arav’s wish?",
          options: [
            "Because he was kind and brave",
            "Because he was rich",
            "Because he cried loudly",
            "Because he found gold",
          ],
          answer: "Because he was kind and brave",
        },
        {
          question: "What is the moral of the story?",
          options: [
            "Kindness and courage bring rewards",
            "Wishing makes life easy",
            "Magic can solve everything",
            "Only rivers can heal people",
          ],
          answer: "Kindness and courage bring rewards",
        },
      ],
    },
    {
      id: 11,
      title: "The Kingdom of Shadows",
      audioUrl: kingdomOfShadows,
      storyText:
        "Far beyond the mountains stood the Kingdom of Shadows — a place where night never ended. The people there had forgotten what sunlight looked like. One day, a young girl named Lira decided to bring back the light. She carried a small lantern and set off toward the forbidden Crystal Peak, where the ancient Sunstone was said to be hidden. Along her journey, she met a wolf trapped under fallen stones. Though she was scared, she freed him. The wolf turned into a guardian spirit and guided her safely through the dark caves. Finally, she reached the top of the mountain and found the Sunstone glowing faintly. With all her strength, she raised it high — and the light burst through the clouds, ending the endless night. When she returned, the kingdom bloomed with life again. The people cheered, calling her the ‘Bringer of Dawn’. Lira smiled, knowing that even one small light can chase away great darkness.",
      questions: [
        {
          question: "Why was the kingdom called the Kingdom of Shadows?",
          options: [
            "Because night never ended there",
            "Because it had many caves",
            "Because everyone wore black",
            "Because it was full of monsters",
          ],
          answer: "Because night never ended there",
        },
        {
          question: "What was Lira searching for?",
          options: [
            "A golden sword",
            "The Sunstone",
            "A magic lantern",
            "A lost treasure",
          ],
          answer: "The Sunstone",
        },
        {
          question: "Who helped Lira on her journey?",
          options: [
            "A guardian wolf",
            "A talking bird",
            "A kind farmer",
            "A mountain fairy",
          ],
          answer: "A guardian wolf",
        },
        {
          question: "What happened when Lira lifted the Sunstone?",
          options: [
            "The light returned to the kingdom",
            "The mountain broke apart",
            "The wolf disappeared forever",
            "The Sunstone turned into ice",
          ],
          answer: "The light returned to the kingdom",
        },
        {
          question: "What is the moral of the story?",
          options: [
            "Even a small light can end great darkness",
            "Never climb mountains alone",
            "Magic stones are dangerous",
            "Night is stronger than day",
          ],
          answer: "Even a small light can end great darkness",
        },
      ],
    },
  ],
};

export default stories;
